import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
//import { HttpModule } from "@angular/http";
import { IonicStorageModule } from "@ionic/storage-angular";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { HttpClientModule } from "@angular/common/http";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { SocialSharing } from "@ionic-native/social-sharing/ngx";
import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
import { SignaturePadModule } from 'angular2-signaturepad';
import { HeaderPageModule } from "./header/header.module";
import { FooterPageModule } from "./footer/footer.module";

//const config: SocketIoConfig = { url: "http://localhost:2021/", options: {} };
/* const config: SocketIoConfig = {
  url: "http://206.81.1.106:2021/",
  options: {},
}; */

const config: SocketIoConfig = {
  url: 'https://socket.courierandbeyond.com/',
  options: {},
};

@NgModule({
  declarations: [AppComponent,],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    //HttpModule,
    HttpClientModule,
    SocketIoModule.forRoot(config),
    SignaturePadModule,
    HeaderPageModule,
    FooterPageModule,
  ],

  providers: [
    FileOpener,
    SocialSharing,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
